import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AsyncStatus } from "../../models/async-status";
import * as enrollmentRepo from "../../repositories/enrollment";
import { RootState } from "../../store/store";
import { PlanDeferralElectionSet } from "../../models/deferrals";

export async function getDeferralData(
  planId: number,
  empId: number
): Promise<PlanDeferralElectionSet> {
  return enrollmentRepo.get(
    `/deferralElectionData/plan/${planId}/employee/${empId}/currentDate`
  );
}

export const fetchDeferrals = createAsyncThunk(
  "fetch-deferral-data",
  async ({ planId, empId }: { planId: number; empId: number }, thunkAPI) => {
    return getDeferralData(planId, empId);
  }
);

interface DeferralsState {
  data: PlanDeferralElectionSet | undefined
  status: AsyncStatus;
}

const initialState: DeferralsState = {
  data: undefined,
  status: AsyncStatus.not_fetched,
};

const deferralsSlice = createSlice({
  name: "deferrals",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDeferrals.pending, (state, action) => {
      return { ...state, status: AsyncStatus.loading };
    });
    builder.addCase(fetchDeferrals.fulfilled, (state, action) => {
      return { ...state, data: action.payload, status: AsyncStatus.done };
    });
    builder.addCase(fetchDeferrals.rejected, (state, action) => {
      return { ...state, status: AsyncStatus.error };
    });
    builder.addDefaultCase((state, action) => state);
  },
});

export default deferralsSlice.reducer;


export const deferralsSelector = (state: RootState) => state.deferrals
